import * as disclaimerTypes from "./disclaimer.type";
import * as authTypes from "../auth/auth.type";

const initialState = {
  disclaimer: null,
  isLoading: false,
  isSaving: false,
  error: null,
  saved: false,

  /**
   * Backend'den disclaimer bilgisi en az bir kez çekildi mi?
   * PrivateRoute bu flag false ise fetch tetikler, sonuç gelene kadar
   * koruma yönlendirmesi yapmaz (loading state).
   */
  initialized: false,

  /**
   * Kullanıcının onay vermesi GEREKİYOR mu?
   *  - true  → /sorumluluk-reddi-beyani dışındaki tüm private route'lar bloklanır
   *  - false → kullanıcı serbest gezebilir
   *  - null  → henüz bilinmiyor (initialized=false ile birlikte gözükür)
   */
  required: null,
};

/**
 * Backend cevabından "kullanıcı onaylamak zorunda mı?" sorusunu çıkarır.
 * - data null/id yoksa: aktif disclaimer yok → required=false
 * - checkedDisclaimerInTheWeek=true ise: önceden onaylanmış ve hâlâ geçerli → required=false
 * - aksi: required=true
 */
const computeRequired = (data) => {
  if (!data || !data.id) return false;
  return data.checkedDisclaimerInTheWeek !== true;
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case disclaimerTypes.GET_DISCLAIMER_PENDING:
      return { ...state, isLoading: true, error: null };

    case disclaimerTypes.GET_DISCLAIMER_FULFILLED: {
      const data = payload?.data ?? null;
      return {
        ...state,
        isLoading: false,
        disclaimer: data,
        initialized: true,
        required: computeRequired(data),
      };
    }

    case disclaimerTypes.GET_DISCLAIMER_REJECTED:
      // Backend hatasında kullanıcıyı kilitleme (yine de portala girebilsin).
      return {
        ...state,
        isLoading: false,
        error: payload,
        disclaimer: null,
        initialized: true,
        required: false,
      };

    case disclaimerTypes.SAVE_DISCLAIMER_CHECK_PENDING:
      return { ...state, isSaving: true, error: null, saved: false };

    case disclaimerTypes.SAVE_DISCLAIMER_CHECK_FULFILLED:
      return {
        ...state,
        isSaving: false,
        saved: true,
        required: false,
        disclaimer: state.disclaimer
          ? { ...state.disclaimer, checkedDisclaimerInTheWeek: true }
          : state.disclaimer,
      };

    case disclaimerTypes.SAVE_DISCLAIMER_CHECK_REJECTED:
      return {
        ...state,
        isSaving: false,
        error: payload,
        saved: false,
      };

    case disclaimerTypes.RESET_DISCLAIMER:
      return initialState;

    // Logout veya login reddi durumunda disclaimer state'ini de sıfırla;
    // aksi halde başka kullanıcı ile login olunduğunda eski required değeri kullanılır.
    case authTypes.LOGOUT_FULFILLED:
    case authTypes.LOGOUT_REJECTED:
    case authTypes.LOGIN_REJECTED:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
